import React from 'react'
import { connect } from 'react-redux';

import CurrencyInput from 'components/CurrencyInput'

import {
  getLoanDetailAmount,
  getLoanDetailAmountError,
} from 'containers/LoanApplication/reducers';

import {
  numberAddCommas,
} from 'servos/formValidations'

import {
  percentageLabel,
} from 'servos/mathHelpers'

class Amount extends React.Component {

  selectedPercentage() {
    const {
      amount,
      totalAmount,
    } = this.props;

    if (amount && totalAmount) {
      return `${percentageLabel(amount / totalAmount)} of your total loan amount`
    } else {
      return ""
    }
  }

  remainingPercentage() {
    const {
      type,
      amount,
      totalAmount,
    } = this.props;

    let remainingRateType = type == 'fixed' ? 'variable' : 'fixed'

    if (amount && totalAmount) {
      let remainingAmount = totalAmount - amount

      if ( remainingAmount => 0) {
        let remainingLabel = numberAddCommas(remainingAmount)
        let remainingPercentageLabel = percentageLabel(remainingAmount/totalAmount)
        return `$${remainingLabel} (${remainingPercentageLabel}) allocated to ${remainingRateType} rate`
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  renderInput() {
    const {
      amount,
      onChange,
      errorMessage,
    } = this.props;

    const readOnly = (onChange == undefined) ? true : false
    return(
      <CurrencyInput
        defaultValue={ amount }
        readOnly={ readOnly }
        onChange={ (value) => onChange(value) }
        errorMessage={errorMessage}
      />
    )
  }

  render(){
    return(
      <div className='card-body bg-pale-green'>
        <div className='row'>
          <div className='col-12 col-sm-4'>
            <div className='form-group mb-0'>
              <label>Split amount allocated</label>
              { this.renderInput() }
            </div>
          </div>
          <div className='col align-self-end text-sm-right mt-3 mb-1'>
            <div className='grey smaller'>
              { this.selectedPercentage() }
            </div>
            <div className='grey smaller'>
              { this.remainingPercentage() }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  amount: getLoanDetailAmount(state, ownProps.type) || 0,
  errorMessage: getLoanDetailAmountError(state, ownProps.type) || 0,
})

export default connect(mapStateToProps)(Amount);
